export default {
  assets: [
    {
      id: 'comp_0',
      layers: [
        {
          ddd: 0,
          ind: 0,
          ty: 4,
          nm: 'Ray1 Outlines 4',
          ks: {
            o: {
              k: 100,
            },
            r: {
              k: -135,
            },
            p: {
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 20,
                  s: [150.031, 149.963, 0],
                  e: [138.031, 160.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 37,
                  s: [138.031, 160.963, 0],
                  e: [150.031, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 52,
                  s: [150.031, 149.463, 0],
                  e: [149.963, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 57,
                  s: [149.963, 149.463, 0],
                  e: [138.031, 160.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 74,
                  s: [138.031, 160.963, 0],
                  e: [150.031, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  t: 89,
                },
              ],
            },
            a: {
              k: [25, 112, 0],
            },
            s: {
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 20,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 52,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 57,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  t: 89,
                },
              ],
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-15.768, 12.386],
                        [0.217, -12.616],
                        [15.768, 12.616],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [1, 0.78, 0.27, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 21.553],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [0.33, -19.236],
                        [-3.96, -12.524],
                        [-19.165, 11.258],
                        [-24.041, 18.885],
                        [-14.988, 18.952],
                        [15.009, 19.171],
                        [24.041, 19.236],
                        [19.302, 11.547],
                        [4.509, -12.454],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [0.99, 0.91, 0.25, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 19.486],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              mn: 'ADBE Vector Group',
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
          sr: 1,
        },
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: 'Ray1 Outlines 3',
          ks: {
            o: {
              k: 100,
            },
            r: {
              k: -90,
            },
            p: {
              k: [
                {
                  i: {
                    x: 0.833,
                    y: 0.833,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p833_0p833_0p333_0',
                  t: 0,
                  s: [150.031, 149.963, 0],
                  e: [135.531, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0.167,
                  },
                  n: '0p667_1_0p167_0p167',
                  t: 15,
                  s: [135.531, 149.963, 0],
                  e: [134.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 17,
                  s: [134.031, 149.963, 0],
                  e: [150.031, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 32,
                  s: [150.031, 149.463, 0],
                  e: [149.963, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 37,
                  s: [149.963, 149.463, 0],
                  e: [134.031, 150.031, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 54,
                  s: [134.031, 150.031, 0],
                  e: [150.031, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p833_1_0p333_0',
                  t: 69,
                  s: [150.031, 149.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p833_0p833_0p333_0',
                  t: 75,
                  s: [150.031, 149.963, 0],
                  e: [135.531, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833,
                  },
                  o: {
                    x: 0.167,
                    y: 0.167,
                  },
                  n: '0p833_0p833_0p167_0p167',
                  t: 90,
                  s: [135.531, 149.963, 0],
                  e: [134.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0.167,
                  },
                  n: '0p667_1_0p167_0p167',
                  t: 92,
                  s: [134.031, 149.963, 0],
                  e: [150.031, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  t: 107,
                },
              ],
            },
            a: {
              k: [25, 112, 0],
            },
            s: {
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 0,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 32,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 37,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 69,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 75,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  t: 107,
                },
              ],
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-15.768, 12.386],
                        [0.217, -12.616],
                        [15.768, 12.616],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [1, 0.78, 0.27, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 21.553],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [0.33, -19.236],
                        [-3.96, -12.524],
                        [-19.165, 11.258],
                        [-24.041, 18.885],
                        [-14.988, 18.952],
                        [15.009, 19.171],
                        [24.041, 19.236],
                        [19.302, 11.547],
                        [4.509, -12.454],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [0.99, 0.91, 0.25, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 19.486],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              mn: 'ADBE Vector Group',
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
          sr: 1,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: 'Ray1 Outlines 2',
          ks: {
            o: {
              k: 100,
            },
            r: {
              k: -45,
            },
            p: {
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 20,
                  s: [150.031, 149.963, 0],
                  e: [139.031, 136.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 37,
                  s: [139.031, 136.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0,
                  },
                  n: '0p667_1_0p167_0',
                  t: 52,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 57,
                  s: [150.031, 149.963, 0],
                  e: [139.031, 136.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 73,
                  s: [139.031, 136.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  t: 89,
                },
              ],
            },
            a: {
              k: [25, 112, 0],
            },
            s: {
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 20,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 52,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 57,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  t: 89,
                },
              ],
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-15.768, 12.386],
                        [0.217, -12.616],
                        [15.768, 12.616],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [1, 0.78, 0.27, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 21.553],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [0.33, -19.236],
                        [-3.96, -12.524],
                        [-19.165, 11.258],
                        [-24.041, 18.885],
                        [-14.988, 18.952],
                        [15.009, 19.171],
                        [24.041, 19.236],
                        [19.302, 11.547],
                        [4.509, -12.454],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [0.99, 0.91, 0.25, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 19.486],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              mn: 'ADBE Vector Group',
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
          sr: 1,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: 'Ray1 Outlines',
          ks: {
            o: {
              k: 100,
            },
            r: {
              k: 0,
            },
            p: {
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 0,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 134.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 16,
                  s: [150.031, 134.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833,
                  },
                  o: {
                    x: 0.167,
                    y: 0.167,
                  },
                  n: '0p833_0p833_0p167_0p167',
                  t: 32,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 37,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 134.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 54,
                  s: [150.031, 134.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0,
                  },
                  n: '0p833_1_0p167_0',
                  t: 69,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 75,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 134.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 92,
                  s: [150.031, 134.463, 0],
                  e: [150.031, 150.031, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  t: 107,
                },
              ],
            },
            a: {
              k: [25, 112, 0],
            },
            s: {
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 0,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 32,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 37,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 69,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 75,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  t: 107,
                },
              ],
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-15.768, 12.386],
                        [0.217, -12.616],
                        [15.768, 12.616],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [1, 0.78, 0.27, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 21.553],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [0.33, -19.236],
                        [-3.96, -12.524],
                        [-19.165, 11.258],
                        [-24.041, 18.885],
                        [-14.988, 18.952],
                        [15.009, 19.171],
                        [24.041, 19.236],
                        [19.302, 11.547],
                        [4.509, -12.454],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [0.99, 0.91, 0.25, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 19.486],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              mn: 'ADBE Vector Group',
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
          sr: 1,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: 'Ray1 Outlines 9',
          ks: {
            o: {
              k: 100,
            },
            r: {
              k: -315,
            },
            p: {
              k: [
                {
                  i: {
                    x: 0.833,
                    y: 0.833,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p833_0p833_0p333_0',
                  t: 20,
                  s: [150.031, 149.963, 0],
                  e: [162.281, 137.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833,
                  },
                  o: {
                    x: 0.167,
                    y: 0.167,
                  },
                  n: '0p833_0p833_0p167_0p167',
                  t: 35,
                  s: [162.281, 137.963, 0],
                  e: [162.781, 137.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0.167,
                  },
                  n: '0p667_1_0p167_0p167',
                  t: 37,
                  s: [162.781, 137.463, 0],
                  e: [150.031, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0,
                  },
                  n: '0p833_1_0p167_0',
                  t: 52,
                  s: [150.031, 149.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p833_0p833_0p333_0',
                  t: 57,
                  s: [150.031, 149.963, 0],
                  e: [162.281, 137.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 0.833,
                  },
                  o: {
                    x: 0.167,
                    y: 0.167,
                  },
                  n: '0p833_0p833_0p167_0p167',
                  t: 72,
                  s: [162.281, 137.963, 0],
                  e: [162.781, 137.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0.167,
                  },
                  n: '0p667_1_0p167_0p167',
                  t: 74,
                  s: [162.781, 137.463, 0],
                  e: [150.031, 149.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  t: 89,
                },
              ],
            },
            a: {
              k: [25, 112, 0],
            },
            s: {
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 20,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 52,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 57,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  t: 89,
                },
              ],
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-15.768, 12.386],
                        [0.217, -12.616],
                        [15.768, 12.616],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [1, 0.78, 0.27, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 21.553],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [0.33, -19.236],
                        [-3.96, -12.524],
                        [-19.165, 11.258],
                        [-24.041, 18.885],
                        [-14.988, 18.952],
                        [15.009, 19.171],
                        [24.041, 19.236],
                        [19.302, 11.547],
                        [4.509, -12.454],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [0.99, 0.91, 0.25, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 19.486],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              mn: 'ADBE Vector Group',
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
          sr: 1,
        },
        {
          ddd: 0,
          ind: 5,
          ty: 4,
          nm: 'Ray1 Outlines 8',
          ks: {
            o: {
              k: 100,
            },
            r: {
              k: -270,
            },
            p: {
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 0,
                  s: [150.031, 149.963, 0],
                  e: [165.281, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 17,
                  s: [165.281, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0,
                  },
                  n: '0p833_1_0p167_0',
                  t: 32,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 37,
                  s: [150.031, 149.963, 0],
                  e: [165.281, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 54,
                  s: [165.281, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0,
                  },
                  n: '0p833_1_0p167_0',
                  t: 69,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 75,
                  s: [150.031, 149.963, 0],
                  e: [165.281, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 92,
                  s: [165.281, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  t: 107,
                },
              ],
            },
            a: {
              k: [25, 112, 0],
            },
            s: {
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 0,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 32,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 37,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 69,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 75,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  t: 107,
                },
              ],
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-15.768, 12.386],
                        [0.217, -12.616],
                        [15.768, 12.616],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [1, 0.78, 0.27, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 21.553],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [0.33, -19.236],
                        [-3.96, -12.524],
                        [-19.165, 11.258],
                        [-24.041, 18.885],
                        [-14.988, 18.952],
                        [15.009, 19.171],
                        [24.041, 19.236],
                        [19.302, 11.547],
                        [4.509, -12.454],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [0.99, 0.91, 0.25, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 19.486],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              mn: 'ADBE Vector Group',
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
          sr: 1,
        },
        {
          ddd: 0,
          ind: 6,
          ty: 4,
          nm: 'Ray1 Outlines 6',
          ks: {
            o: {
              k: 100,
            },
            r: {
              k: -225,
            },
            p: {
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 20,
                  s: [150.031, 149.963, 0],
                  e: [161.531, 161.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 37,
                  s: [161.531, 161.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0,
                  },
                  n: '0p667_1_0p167_0',
                  t: 52,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 57,
                  s: [150.031, 149.963, 0],
                  e: [161.531, 161.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 74,
                  s: [161.531, 161.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  t: 89,
                },
              ],
            },
            a: {
              k: [25, 112, 0],
            },
            s: {
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 20,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 52,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 57,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  t: 89,
                },
              ],
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-15.768, 12.386],
                        [0.217, -12.616],
                        [15.768, 12.616],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [1, 0.78, 0.27, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 21.553],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [0.33, -19.236],
                        [-3.96, -12.524],
                        [-19.165, 11.258],
                        [-24.041, 18.885],
                        [-14.988, 18.952],
                        [15.009, 19.171],
                        [24.041, 19.236],
                        [19.302, 11.547],
                        [4.509, -12.454],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [0.99, 0.91, 0.25, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 19.486],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              mn: 'ADBE Vector Group',
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
          sr: 1,
        },
        {
          ddd: 0,
          ind: 7,
          ty: 4,
          nm: 'Ray1 Outlines 5',
          ks: {
            o: {
              k: 100,
            },
            r: {
              k: -180,
            },
            p: {
              k: [
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 0,
                  s: [150.031, 149.963, 0],
                  e: [149.531, 165.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 16,
                  s: [149.531, 165.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0,
                  },
                  n: '0p833_1_0p167_0',
                  t: 32,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 37,
                  s: [150.031, 149.963, 0],
                  e: [149.531, 165.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 53,
                  s: [149.531, 165.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.833,
                    y: 1,
                  },
                  o: {
                    x: 0.167,
                    y: 0,
                  },
                  n: '0p833_1_0p167_0',
                  t: 69,
                  s: [150.031, 149.963, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 75,
                  s: [150.031, 149.963, 0],
                  e: [149.531, 165.463, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  i: {
                    x: 0.667,
                    y: 1,
                  },
                  o: {
                    x: 0.333,
                    y: 0,
                  },
                  n: '0p667_1_0p333_0',
                  t: 91,
                  s: [149.531, 165.463, 0],
                  e: [150.031, 149.963, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                {
                  t: 107,
                },
              ],
            },
            a: {
              k: [25, 112, 0],
            },
            s: {
              k: [
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 0,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 32,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 37,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 69,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  i: {
                    x: [0.833, 0.833, 0.833],
                    y: [0.833, 0.833, 0.833],
                  },
                  o: {
                    x: [0.167, 0.167, 0.167],
                    y: [0.167, 0.167, 0.167],
                  },
                  n: [
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                    '0p833_0p833_0p167_0p167',
                  ],
                  t: 75,
                  s: [100, 100, 100],
                  e: [100, 100, 100],
                },
                {
                  t: 107,
                },
              ],
            },
          },
          ao: 0,
          shapes: [
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-15.768, 12.386],
                        [0.217, -12.616],
                        [15.768, 12.616],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [1, 0.78, 0.27, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 21.553],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [0.33, -19.236],
                        [-3.96, -12.524],
                        [-19.165, 11.258],
                        [-24.041, 18.885],
                        [-14.988, 18.952],
                        [15.009, 19.171],
                        [24.041, 19.236],
                        [19.302, 11.547],
                        [4.509, -12.454],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'fl',
                  c: {
                    k: [0.99, 0.91, 0.25, 1],
                  },
                  o: {
                    k: 100,
                  },
                  nm: 'Fill 1',
                  mn: 'ADBE Vector Graphic - Fill',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [24.291, 19.486],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 2',
              np: 2,
              mn: 'ADBE Vector Group',
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
          sr: 1,
        },
      ],
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 0,
      ty: 0,
      nm: 'rays',
      refId: 'comp_0',
      ks: {
        o: {
          k: 100,
        },
        r: {
          k: [
            {
              i: {
                x: [0.667],
                y: [1],
              },
              o: {
                x: [0.333],
                y: [0],
              },
              n: ['0p667_1_0p333_0'],
              t: 0,
              s: [0],
              e: [360],
            },
            {
              t: 120,
            },
          ],
        },
        p: {
          k: [150, 150, 0],
        },
        a: {
          k: [150, 150, 0],
        },
        s: {
          k: [100, 100, 100],
        },
      },
      ao: 0,
      w: 300,
      h: 300,
      ip: 0,
      op: 120,
      st: 0,
      bm: 0,
      sr: 1,
    },
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: 'Sun Outlines',
      ks: {
        o: {
          k: 100,
        },
        r: {
          k: 0,
        },
        p: {
          k: [150, 150, 0],
        },
        a: {
          k: [68.25, 68.25, 0],
        },
        s: {
          k: [
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 0.667],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0.333],
              },
              n: [
                '0p667_1_0p333_0',
                '0p667_1_0p333_0',
                '0p667_0p667_0p333_0p333',
              ],
              t: 0,
              s: [100, 100, 100],
              e: [103.926, 103.926, 100],
            },
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 0.667],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0.333],
              },
              n: [
                '0p667_1_0p333_0',
                '0p667_1_0p333_0',
                '0p667_0p667_0p333_0p333',
              ],
              t: 20,
              s: [103.926, 103.926, 100],
              e: [100, 100, 100],
            },
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 0.667],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0.333],
              },
              n: [
                '0p667_1_0p333_0',
                '0p667_1_0p333_0',
                '0p667_0p667_0p333_0p333',
              ],
              t: 40,
              s: [100, 100, 100],
              e: [103.926, 103.926, 100],
            },
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 0.667],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0.333],
              },
              n: [
                '0p667_1_0p333_0',
                '0p667_1_0p333_0',
                '0p667_0p667_0p333_0p333',
              ],
              t: 60,
              s: [103.926, 103.926, 100],
              e: [100, 100, 100],
            },
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 0.667],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0.333],
              },
              n: [
                '0p667_1_0p333_0',
                '0p667_1_0p333_0',
                '0p667_0p667_0p333_0p333',
              ],
              t: 80,
              s: [100, 100, 100],
              e: [103.926, 103.926, 100],
            },
            {
              i: {
                x: [0.667, 0.667, 0.667],
                y: [1, 1, 0.667],
              },
              o: {
                x: [0.333, 0.333, 0.333],
                y: [0, 0, 0.333],
              },
              n: [
                '0p667_1_0p333_0',
                '0p667_1_0p333_0',
                '0p667_0p667_0p333_0p333',
              ],
              t: 100,
              s: [103.926, 103.926, 100],
              e: [100, 100, 100],
            },
            {
              t: 120,
            },
          ],
        },
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                k: {
                  i: [
                    [0, 34.738],
                    [10.396, 11.239],
                    [0.917, 0.925],
                    [0, 0],
                    [-0.185, -0.341],
                    [16.682, -21.955],
                    [31.687, 14.195],
                    [1.604, 1.01],
                    [0.231, 0.114],
                    [-1.547, -1.432],
                    [-15.155, 0],
                  ],
                  o: [
                    [0, -16.479],
                    [-0.07, -0.076],
                    [-0.947, -0.956],
                    [0, 0],
                    [13.11, 24.151],
                    [-21.824, 28.723],
                    [-0.461, -0.207],
                    [-1.832, -1.152],
                    [1.142, 1.521],
                    [10.881, 8.948],
                    [34.738, 0],
                  ],
                  v: [
                    [55.159, -8.217],
                    [38.391, -50.945],
                    [36.732, -52.624],
                    [34.592, -54.784],
                    [36.652, -50.937],
                    [34.044, 19.257],
                    [-47.592, 38.033],
                    [-51.842, 35.742],
                    [-55.159, 33.38],
                    [-47.798, 40.455],
                    [-7.842, 54.784],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-157.841, 141.784],
                        [142.159, 141.784],
                        [142.159, -158.216],
                        [-157.841, -158.216],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ind: 1,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-157.841, -158.216],
                        [142.159, -158.216],
                        [142.159, 141.784],
                        [-157.841, 141.784],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [0, 0],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
            },
            {
              ty: 'fl',
              c: {
                k: [1, 0.7, 0.2, 1],
              },
              o: {
                k: 100,
              },
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
            },
            {
              ty: 'tr',
              p: {
                k: [76.091, 76.466],
                ix: 2,
              },
              a: {
                k: [0, 0],
                ix: 1,
              },
              s: {
                k: [100, 100],
                ix: 3,
              },
              r: {
                k: 0,
                ix: 6,
              },
              o: {
                k: 100,
                ix: 7,
              },
              sk: {
                k: 0,
                ix: 4,
              },
              sa: {
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 1',
          np: 4,
          mn: 'ADBE Vector Group',
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                k: {
                  i: [
                    [34.738, 0],
                    [0, 34.738],
                    [-34.738, 0],
                    [0, -34.738],
                  ],
                  o: [
                    [-34.738, 0],
                    [0, -34.738],
                    [34.738, 0],
                    [0, 34.738],
                  ],
                  v: [
                    [0, 63],
                    [-63, 0],
                    [0, -63],
                    [63, 0],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-150, 150],
                        [150, 150],
                        [150, -150],
                        [-150, -150],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ind: 1,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-150, -150],
                        [150, -150],
                        [150, 150],
                        [-150, 150],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [0, 0],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
            },
            {
              ty: 'fl',
              c: {
                k: [1, 0.78, 0.27, 1],
              },
              o: {
                k: 100,
              },
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
            },
            {
              ty: 'tr',
              p: {
                k: [68.25, 68.25],
                ix: 2,
              },
              a: {
                k: [0, 0],
                ix: 1,
              },
              s: {
                k: [100, 100],
                ix: 3,
              },
              r: {
                k: 0,
                ix: 6,
              },
              o: {
                k: 100,
                ix: 7,
              },
              sk: {
                k: 0,
                ix: 4,
              },
              sa: {
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 2',
          np: 4,
          mn: 'ADBE Vector Group',
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ks: {
                k: {
                  i: [
                    [37.495, 0],
                    [0, -37.495],
                    [-37.495, 0],
                    [0, 37.495],
                  ],
                  o: [
                    [-37.495, 0],
                    [0, 37.495],
                    [37.495, 0],
                    [0, -37.495],
                  ],
                  v: [
                    [0, -68],
                    [-68, 0],
                    [0, 68],
                    [68, 0],
                  ],
                  c: true,
                },
              },
              nm: 'Path 1',
              mn: 'ADBE Vector Shape - Group',
            },
            {
              ty: 'gr',
              it: [
                {
                  ind: 0,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-150, 150],
                        [150, 150],
                        [150, -150],
                        [-150, -150],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 1',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ind: 1,
                  ty: 'sh',
                  ks: {
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                      ],
                      v: [
                        [-150, -150],
                        [150, -150],
                        [150, 150],
                        [-150, 150],
                      ],
                      c: true,
                    },
                  },
                  nm: 'Path 2',
                  mn: 'ADBE Vector Shape - Group',
                },
                {
                  ty: 'tr',
                  p: {
                    k: [0, 0],
                    ix: 2,
                  },
                  a: {
                    k: [0, 0],
                    ix: 1,
                  },
                  s: {
                    k: [100, 100],
                    ix: 3,
                  },
                  r: {
                    k: 0,
                    ix: 6,
                  },
                  o: {
                    k: 100,
                    ix: 7,
                  },
                  sk: {
                    k: 0,
                    ix: 4,
                  },
                  sa: {
                    k: 0,
                    ix: 5,
                  },
                  nm: 'Transform',
                },
              ],
              nm: 'Group 1',
              np: 2,
              mn: 'ADBE Vector Group',
            },
            {
              ty: 'mm',
              mm: 4,
              nm: 'Merge Paths 1',
              mn: 'ADBE Vector Filter - Merge',
            },
            {
              ty: 'fl',
              c: {
                k: [0.99, 0.91, 0.25, 1],
              },
              o: {
                k: 100,
              },
              nm: 'Fill 1',
              mn: 'ADBE Vector Graphic - Fill',
            },
            {
              ty: 'tr',
              p: {
                k: [68.25, 68.25],
                ix: 2,
              },
              a: {
                k: [0, 0],
                ix: 1,
              },
              s: {
                k: [100, 100],
                ix: 3,
              },
              r: {
                k: 0,
                ix: 6,
              },
              o: {
                k: 100,
                ix: 7,
              },
              sk: {
                k: 0,
                ix: 4,
              },
              sa: {
                k: 0,
                ix: 5,
              },
              nm: 'Transform',
            },
          ],
          nm: 'Group 3',
          np: 4,
          mn: 'ADBE Vector Group',
        },
      ],
      ip: 0,
      op: 120,
      st: 0,
      bm: 0,
      sr: 1,
    },
  ],
  v: '4.5.4',
  ddd: 0,
  ip: 0,
  op: 120,
  fr: 30,
  w: 300,
  h: 300,
};